import styled from "styled-components";

export const StyledButton = styled("button")<any>`
float: ${(p) => p.float || "left"};
height: ${(p) => p.height || "32px"}; 
width:${(p) => p.width || "80px"};
color: ${(p) => p.color || "black"}; 
background:${(p)=> p.background || "linear-gradient(0deg, rgba(246,246,246,1), rgba(205,204,204,1), rgba(246,246,246,1))"};
cursor: pointer;
font-size: ${(p) => p.fontSize || "15px"}; 
padding: 2px 10px 2px;
position: relative;
font-family: Arial, Helvetica, sans-serif;
border: 1px none;
box-shadow: 1px 1px 1px 1px #aaaaaa;
border-radius: 2px;
box-sizing: border-box;
transition: all 0.3s ease-in-out;
&:hover {
  text-underline-position: under;
  text-decoration: underline;
}
&:active,
&:focus {
  border: 1px solid rgb(153, 150, 150);
}
&:disabled{
  opacity: 0.6;
  cursor: not-allowed;
  transition:none;
  &:active,
  &:focus {
    border: none;
  }
  &:hover {
    text-underline-position: none;
    text-decoration: none;
  }
`;
